import type { StatusMapping, KieSunoModelConfig } from './types';

export const kieSunoStatusMapping: StatusMapping = {
    taskIdPath: 'data.taskId',
    statePath: 'data.status',
    processing: ['PENDING', 'TEXT_SUCCESS', 'FIRST_SUCCESS'],
    success: ['SUCCESS'],
    failed: ['CREATE_TASK_FAILED', 'GENERATE_AUDIO_FAILED', 'SENSITIVE_WORD_ERROR'],
    audioUrlPath: 'data.response.sunoData[*].audioUrl',
    lyricsPath: 'data.response.sunoData[0].prompt',
    errorPath: 'data.errorMessage',
};

export const kieSunoModelConfigs: Record<string, KieSunoModelConfig> = {
    'suno-v5.5-generate': {
        // https://docs.kie.ai/cn/suno-api/generate-music
        createPath: '/api/v1/generate',
        pollPath: '/api/v1/generate/record-info',
        buildInput: (params) => {
            const { text, voice, providerOptions } = params;
            const style = (text || '').trim();
            const lyrics = typeof providerOptions?.lyrics === 'string' ? providerOptions.lyrics.trim() : '';
            const instrumental = voice === 'Instrumental Mode';
            // 自定义模式
            if (!instrumental && lyrics) {
                return {
                    model: 'V5_5',
                    prompt: lyrics.slice(0, 5000),
                    style: style.slice(0, 1000),
                    title: Math.random().toString(36).slice(2, 10),
                    instrumental: false,
                    // system
                    customMode: true,
                    callBackUrl: 'https://api.example.com/callback',
                };
            // 纯音乐模式
            } else if (instrumental) {
                return {
                    model: 'V5_5',
                    prompt: style.slice(0, 500),
                    instrumental: true,
                    // system
                    customMode: false,
                    callBackUrl: 'https://api.example.com/callback',
                };
            // 自动模式
            } else {
                return {
                    model: 'V5_5',
                    prompt: style.slice(0, 500),
                    instrumental: false,
                    // system
                    customMode: false,
                    callBackUrl: 'https://api.example.com/callback',
                };
            }
        },
    },
    'suno-v5-generate': {
        // https://docs.kie.ai/cn/suno-api/generate-music
        createPath: '/api/v1/generate',
        pollPath: '/api/v1/generate/record-info',
        buildInput: (params) => {
            const { text, voice, providerOptions } = params;
            const style = (text || '').trim();
            const lyrics = typeof providerOptions?.lyrics === 'string' ? providerOptions.lyrics.trim() : '';
            const instrumental = voice === 'Instrumental Mode';
            // 自定义模式
            if (!instrumental && lyrics) {
                return {
                    model: 'V5',
                    prompt: lyrics.slice(0, 5000),
                    style: style.slice(0, 1000),
                    title: Math.random().toString(36).slice(2, 10),
                    instrumental: false,
                    // system
                    customMode: true,
                    callBackUrl: 'https://api.example.com/callback',
                };
            // 纯音乐模式
            } else if (instrumental) {
                return {
                    model: 'V5',
                    prompt: style.slice(0, 500),
                    instrumental: true,
                    // system
                    customMode: false,
                    callBackUrl: 'https://api.example.com/callback',
                };
            // 自动模式
            } else {
                return {
                    model: 'V5',
                    prompt: style.slice(0, 500),
                    instrumental: false,
                    // system
                    customMode: false,
                    callBackUrl: 'https://api.example.com/callback',
                };
            }
        },
    },
};
